import { i18n } from "@src/i18n/i18n";

type XAxisBuilderAxisLabelOptions = {
  formatter?: (value: any) => string;
};

type XAxisBuilderNameTextStyleOptions = {
  verticalAlign?: string;
  padding?: number[];
};

type XAxisOptions = {
  name: string;
  nameLocation: string;
  type: string;
  data: any[];
  axisLabel: XAxisBuilderAxisLabelOptions;
  nameTextStyle: XAxisBuilderNameTextStyleOptions;
  boundaryGap: boolean;
};

export class XAxisBuilder {
  private name: string;
  private nameLocation: string;
  private type: string;
  private data: any[];
  private axisLabel: XAxisBuilderAxisLabelOptions;
  private nameTextStyle: XAxisBuilderNameTextStyleOptions;
  private boundaryGap: boolean;

  constructor() {
    this.name = i18n("modules.ourNodeDetailsPanel.timeSeriesDataTimeLabel");
    this.nameLocation = "middle";
    this.type = "category";
    this.data = [];
    this.axisLabel = {
      formatter: (value: any) => {
        // Default formatter, can be overridden
        return value;
      },
    };
    this.nameTextStyle = {
      verticalAlign: "bottom",
      padding: [0, 0, -39, 0],
    };
    this.boundaryGap = true;
  }

  setName(value: string): this {
    this.name = value;
    return this;
  }

  setNameLocation(value: string): this {
    this.nameLocation = value;
    return this;
  }

  setType(value: string): this {
    this.type = value;
    return this;
  }

  setData(value: any[]): this {
    this.data = value;
    return this;
  }

  setAxisLabelFormatter(options: XAxisBuilderAxisLabelOptions): this {
    this.axisLabel = {
      ...this.axisLabel,
      ...options,
    };
    return this;
  }

  setFormatter(fn: (value: any) => string): this {
    this.axisLabel.formatter = fn;
    return this;
  }

  setNameTextStyle(options: XAxisBuilderNameTextStyleOptions): this {
    this.nameTextStyle = {
      ...this.nameTextStyle,
      ...options,
    };
    return this;
  }

  setBoundaryGap(value: boolean): this {
    this.boundaryGap = value;
    return this;
  }

  build(): XAxisOptions {
    return {
      name: this.name,
      nameLocation: this.nameLocation,
      type: this.type,
      data: this.data,
      axisLabel: this.axisLabel,
      nameTextStyle: this.nameTextStyle,
      boundaryGap: this.boundaryGap,
    };
  }
}
